import { get, noop } from 'lodash'
import React from 'react'
import styled from 'styled-components'

import Button from '../../../Button'
import CopyClipboardTrigger from '../../../CopyClipboardTrigger'
import Field from '../../../Field'
import Form from '../../../Form'
import Input from '../../../Input'
import { AS_URI, COPYPASTE, QRCODE } from '../../constant'
import { TFaData, TSubmitQRCode } from '../../types'

const ButtonFormWrapper = styled.div`
  max-height: 40px;
`

type TValidationStep = {
  faMethod?: string | null
  faData?: TFaData
  form?: any
  setForm?: (val: any) => void
  loadingValidation?: boolean
  onSubmitQRCode?: TSubmitQRCode
}
const ValidationStep = (props: TValidationStep): React.ReactElement => {
  const {
    faMethod,
    faData,
    form,
    setForm,
    loadingValidation,
    onSubmitQRCode = noop,
  } = props

  return (
    <div>
      {faMethod === AS_URI && (
        <div>
          <Input
            name={i18n.t(`2fa_otp`, `OTP`)}
            label={i18n.t(`2fa_otp-auth`, `OTP Auth`)}
            value={decodeURIComponent(get(faData, 'as_uri', ''))}
            readOnly
            className="mb-1"
          />
          <a
            href={decodeURIComponent(get(faData, 'as_uri', ''))}
            target="_blank"
            rel="noreferrer"
          >
            <Button primary>{i18n.t(`2fa_go-to-uri`, `Go to URI 2FA`)}</Button>
          </a>
        </div>
      )}

      {faMethod === QRCODE && (
        <div>
          <div className="d-flex justify-content-center w-100 font-weight-bold text-warning">
            {i18n.t(
              `2fa_scan-qr-code`,
              `Via Authenticator App. Z.B. Google Authenticator`,
            )}
          </div>
          <div className="d-flex justify-content-center w-100">
            <img
              src={`data:image/svg+xml;utf8,${encodeURIComponent(
                get(faData, 'as_qr_code', ''),
              )}`}
            />
          </div>

          <div className="d-flex justify-content-center w-100">
            <Form setForm={setForm} onSubmit={onSubmitQRCode}>
              <Field
                name="2fa_code"
                disabled={loadingValidation}
                placeholder={i18n.t(
                  `2fa_validation-step-placeholder`,
                  `Gültiges 2FA Token`,
                )}
                validate={(val) => {
                  if (
                    val == undefined ||
                    val == '' ||
                    (val && val.trim() === '')
                  )
                    return i18n.t(`2fa_invalid-code`, `Ungültiges Token`)
                }}
              >
                <Input />
              </Field>
            </Form>

            {form && (
              <ButtonFormWrapper>
                <Button
                  className="ml-1"
                  primary
                  onClick={form.submit}
                  disabled={loadingValidation}
                >
                  {i18n.t(`2fa_submit`, `Fortfahren`)}
                </Button>
              </ButtonFormWrapper>
            )}
          </div>
        </div>
      )}

      {faMethod === COPYPASTE && (
        <div className="mt-1">
          <div className="d-flex justify-content-center w-100 font-weight-bold text-warning text-center mb-1">
            {i18n.t(
              `2fa_copy_code`,
              `Kopieren Sie den Code und nutzen Sie ihn in einer Authentifizerungsapp, z.B. Google Authenticator`,
            )}
          </div>
          <div className="d-flex w-100">
            <Input
              readOnly
              value={get(faData, 'as_string', '')}
              className="w-100"
            />
            <CopyClipboardTrigger content={get(faData, 'as_string', '')}>
              <div>
                <Button primary className="w-100">
                  {i18n.t(`2fa_copy-paste-content`, `Kopieren`)}
                </Button>
              </div>
            </CopyClipboardTrigger>
          </div>

          <div className="d-flex justify-content-center w-100 mt-2">
            <Form setForm={setForm} onSubmit={onSubmitQRCode}>
              <Field
                name="2fa_code"
                disabled={loadingValidation}
                placeholder={i18n.t(
                  `2fa_validation-step-placeholder`,
                  `Gültiges 2FA Token`,
                )}
                validate={(val) => {
                  if (
                    val == undefined ||
                    val == '' ||
                    (val && val.trim() === '')
                  )
                    return i18n.t(`2fa_invalid-code`, `Ungültiges Token`)
                }}
              >
                <Input />
              </Field>
            </Form>

            {form && (
              <ButtonFormWrapper>
                <Button
                  className="ml-2"
                  primary
                  onClick={form.submit}
                  disabled={loadingValidation}
                >
                  {i18n.t(`2fa_submit`, `Fortfahren`)}
                </Button>
              </ButtonFormWrapper>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default ValidationStep
